export default __webpack_public_path__ + "static/media/homelogo.bd452db5.jpeg";